var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-ai",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#fff",
    d: "M-167.86.45h429.52v256.07h-429.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-167.86.45l-.018 19.22 102.5 63.22 38.565 1.34L-167.863.45z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-123.97.45L.29 78.366V.45h-124.26z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.866.45v99.468h-184.73v56.84h184.73v99.467h56.84v-99.468h184.73v-56.84H73.705V.45h-56.84z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.283.45v73.417L211.853 1.02 90.283.45z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.12 81.87l34.19-.33L261.13 1.02l-35.24.688L94.12 81.87z",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.78 22.495L158.32 82.89l100.11.45v89.995h-85.258l84.47 54.942 1.24 27.948-45.117-.647-123.48-72.77v73.417H.29v-73.417l-115.83 73.22-52.315.197v255.78h852.58V.455l-424.04-.46m-428.54 28.87l-.45 53.12 89.757 1.35-89.307-54.472zm-.005 144.465v54.47l85.258-53.9-85.258-.57z",
    fill: "#006"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.45 175.58l-35.543-.33 133.97 80.07-.88-18.318-97.55-61.422zm-295.02 81.09L-8.95 177.5l-32.994.262-125.92 78.79",
    fill: "#c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 245.108l2.165 2.166-2.165-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 245.108l2.166 2.166-2.165-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 247.274l2.164 2.165-2.165-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 247.274l2.166 2.165-2.166-2.166z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 247.274l2.166 2.165-2.165-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.817 249.44l2.166 2.165-2.166-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 249.44l2.165 2.165-2.165-2.166z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 249.44l2.166 2.165-2.167-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.628 253.36c0 55.95-6.45 119.004 35.255 162.823 8.58 9.014 24.9 29.572 38.892 28.783 14.647-.825 33.483-22.5 41.86-33.114 36.304-47.754 30.533-104.713 31.767-160.14-16.393 7.363-24.557 9.788-38.892 9.745-10.618 1.09-26.998-6.045-36.792-10.714-6.4 4.275-15.687 9.373-32.374 9.945-19.273.848-25.38-2.418-39.716-7.33z",
    fill: "#cc3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 249.44l2.166 2.165-2.166-2.166z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 249.44l2.165 2.165-2.165-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.402 249.44l2.166 2.165-2.166-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.983 251.605l2.165 2.165-2.165-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.148 251.605l2.166 2.165-2.166-2.165z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 251.605l2.165 2.165-2.166-2.165z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 251.605l2.165 2.165-2.165-2.165z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 251.605l2.166 2.165-2.166-2.165z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 251.605l2.165 2.165-2.165-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 251.605l2.165 2.165-2.165-2.165z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 251.605l2.165 2.165-2.165-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 251.605l2.166 2.165-2.166-2.165z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 251.605l2.165 2.165-2.165-2.165z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 251.605l2.165 2.165-2.164-2.165z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07 251.605l2.167 2.165-2.166-2.165z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.237 251.605l2.165 2.165-2.165-2.165z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 253.77l2.165 2.166-2.165-2.166z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 253.77l2.166 2.166-2.166-2.166z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 253.77l2.165 2.166-2.164-2.166z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 253.77l2.165 2.166-2.164-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 253.77l2.167 2.166-2.166-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 253.77l2.165 2.166-2.165-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 253.77l2.166 2.166-2.166-2.166z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.068 259.444c-1.165 29.392-.27 62.49 4.324 93.94 5.08 16.43 4.4 25.454 11.95 35.3l105.67-.822c6.368-10.36 11.09-26.068 11.7-32.313 5.9-31.763 6.04-66.814 6.182-98.164-10.626 5.65-24.542 9.652-38.048 7.895-10.827-.824-20.832-3.296-32.482-9.88-10.107 6.054-13.63 8.818-30.317 9.525-12.993.64-23.518 1.693-38.98-5.482z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 253.77l2.166 2.166-2.165-2.166z",
    fill: "#f2f1d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 253.77l2.166 2.166-2.165-2.166z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 253.77l2.165 2.166-2.165-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 253.77l2.166 2.166-2.166-2.166z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 253.77l2.165 2.166-2.166-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 253.77l2.165 2.166-2.166-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 253.77l2.165 2.166-2.166-2.166z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 253.77l2.165 2.166-2.165-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 253.77l2.166 2.166-2.166-2.166z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 253.77l2.165 2.166-2.164-2.166m-129.93 2.166l2.165 2.165-2.164-2.164z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 255.936l2.167 2.165-2.166-2.164z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 255.936l2.165 2.165-2.165-2.164z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 255.936l2.166 2.165-2.166-2.164z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 255.936l2.165 2.165-2.165-2.164m28.15 0l2.167 2.165-2.166-2.164z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 255.936l2.165 2.165-2.165-2.164z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 255.936l2.166 2.165-2.166-2.164z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 255.936l2.165 2.165-2.164-2.164z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 255.936l2.166 2.165-2.167-2.164z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 255.936l2.164 2.165-2.165-2.164z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 255.936l2.166 2.165-2.166-2.164z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 255.936l2.165 2.165-2.165-2.164z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 255.936l2.165 2.165-2.166-2.164z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 255.936l2.165 2.165-2.165-2.164z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 255.936l2.166 2.165-2.166-2.164z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 255.936l2.165 2.165-2.165-2.164z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 255.936l2.166 2.165-2.166-2.164z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 255.936l2.165 2.165-2.165-2.164z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 255.936l2.166 2.165-2.166-2.164z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.694 256.65l1.443.722-1.443-.722z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 258.1l2.165 2.167-2.166-2.166z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 258.1l2.165 2.167-2.166-2.166z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.088 258.816l1.443.722-1.442-.722z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 258.1l2.164 2.167-2.165-2.166z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 258.1l2.166 2.167-2.166-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 258.1l2.165 2.167-2.165-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 258.1l2.166 2.167-2.165-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 258.1l2.166 2.167-2.166-2.166z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 258.1l2.165 2.167-2.166-2.166z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 258.1l2.165 2.167-2.166-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 258.1l2.166 2.167-2.166-2.166z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 258.1l2.165 2.167-2.165-2.166z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 258.1l2.166 2.167-2.166-2.166z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 258.1l2.165 2.167-2.165-2.166z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88 258.816l1.443.722-1.442-.722z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 258.1l2.167 2.167-2.166-2.166z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 258.1l2.165 2.167-2.165-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 258.1l2.166 2.167-2.166-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 258.1l2.165 2.167-2.165-2.166z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.37 258.816l1.443.722-1.443-.722z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 258.1l2.166 2.167-2.165-2.166z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 258.1l2.166 2.167-2.166-2.166z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 258.1l2.165 2.167-2.165-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 258.1l2.165 2.167-2.164-2.166z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07 258.1l2.167 2.167-2.166-2.166z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 260.267l2.165 2.165-2.165-2.165z",
    fill: "#f2f1d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 260.267l2.166 2.165-2.166-2.165z",
    fill: "#e0dea1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 260.267l2.165 2.165-2.164-2.165z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 260.267l2.165 2.165-2.164-2.165z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 260.267l2.167 2.165-2.166-2.165z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 260.267l2.166 2.165-2.166-2.165z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 260.267l2.165 2.165-2.166-2.165z",
    fill: "#e1e18c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 260.267l2.165 2.165-2.166-2.165z",
    fill: "#d4d456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 260.267l2.165 2.165-2.166-2.165z",
    fill: "#e1e18c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 260.267l2.165 2.165-2.165-2.165z",
    fill: "#eeedc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 262.432l2.165 2.166-2.165-2.166z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 262.432l2.166 2.166-2.166-2.166z",
    fill: "#e0dea1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 262.432l2.165 2.166-2.165-2.166z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 262.432l2.166 2.166-2.167-2.166z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 262.432l2.165 2.166-2.166-2.166z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 262.432l2.165 2.166-2.165-2.166z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 262.432l2.166 2.166-2.166-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 262.432l2.165 2.166-2.165-2.166z",
    fill: "#eeedc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 262.432l2.166 2.166-2.166-2.166z",
    fill: "#e1e18c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 262.432l2.165 2.166-2.164-2.166z",
    fill: "#d4d456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 262.432l2.165 2.166-2.165-2.166z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 262.432l2.166 2.166-2.166-2.166z",
    fill: "#e1e18c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 262.432l2.165 2.166-2.165-2.166z",
    fill: "#eeedc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 262.432l2.166 2.166-2.166-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 264.598l2.166 2.165-2.166-2.165z",
    fill: "#f2f1d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 264.598l2.165 2.165-2.165-2.165z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 264.598l2.166 2.165-2.165-2.165z",
    fill: "#eeedc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.578 265.312l1.442.722-1.442-.722z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 264.598l2.166 2.165-2.166-2.165z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 264.598l4.33 4.33v-4.33h-4.33z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 264.598l2.165 2.165-2.165-2.165z",
    fill: "#f2f1d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 264.598l2.166 2.165-2.166-2.165z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 264.598l2.165 2.165-2.165-2.165z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.874 265.312l1.442.722-1.442-.722z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 264.598l2.166 2.165-2.166-2.165z",
    fill: "#e0dea1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.37 265.312l1.443.722-1.443-.722z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 264.598l2.166 2.165-2.165-2.165z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 266.763l2.165 2.166-2.165-2.167z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 266.763l2.166 2.166-2.166-2.167z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 268.93l2.165 2.164-2.165-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 268.93l2.165 2.164-2.164-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 271.094l2.165 2.166-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 271.094l2.165 2.166-2.164-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 273.26l2.165 2.165-2.166-2.165m8.66 0l2.167 2.165-2.166-2.165z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 273.26l2.164 2.165-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 273.26l2.166 2.165-2.166-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 273.26l2.166 2.165-2.166-2.165z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 273.26l2.165 2.165-2.165-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 275.425l2.165 2.166-2.166-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 275.425l2.167 2.166-2.166-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 275.425l2.166 2.166-2.166-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 275.425l2.165 2.166-2.165-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 275.425l2.166 2.166-2.167-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 275.425l2.166 2.166-2.166-2.165z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 275.425l2.165 2.166-2.165-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 277.59l2.165 2.166-2.166-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 277.59l2.165 2.166-2.165-2.165m28.15 0l2.167 2.166-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 277.59l2.165 2.166-2.166-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 279.756l2.165 2.166-2.166-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 279.756l2.165 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 279.756l2.165 2.166-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 279.756l2.165 2.166-2.165-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 281.922l2.165 2.165-2.166-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 281.922l2.165 2.165-2.164-2.165z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 281.922l2.167 2.165-2.166-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 284.087l2.165 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 284.087l2.165 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 284.087l2.166 2.166-2.167-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 284.087l2.164 2.166-2.165-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 284.087l2.166 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 284.087l4.33 4.33-4.33-4.33z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.085 284.087l2.166 2.166-2.165-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 286.253l2.165 2.165-2.166-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 286.253l2.166 2.165-2.165-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 286.253l2.166 2.165-2.166-2.165zm8.662 0l2.166 2.165-2.166-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 286.253l2.165 2.165-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 288.418l2.166 2.166-2.166-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 288.418l2.165 2.166-2.165-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 288.418l2.166 2.166-2.165-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 288.418l2.165 2.166-2.166-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 288.418l2.165 2.166-2.165-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 288.418l2.165 2.166-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 288.418l2.166 2.166-2.167-2.166z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 288.418l2.164 2.166-2.165-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 288.418l2.166 2.166-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 290.584l2.166 2.165-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 290.584l2.166 2.165-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 290.584l2.166 2.165-2.166-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 290.584l2.166 2.165-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 292.75l2.165 2.165-2.165-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 292.75l2.164 2.165-2.165-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 292.75l2.165 2.165-2.164-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 292.75l2.166 2.165-2.166-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 294.915l2.165 2.165-2.165-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 294.915l2.166 2.165-2.167-2.165m34.648 0l2.167 2.165-2.166-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 294.915l2.166 2.165-2.166-2.165z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 297.08l2.165 2.166-2.166-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 297.08l2.165 2.166-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 297.08l2.166 2.166-2.167-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 297.08l2.167 2.166-2.166-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 297.08l2.165 2.166-2.165-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 299.246l2.166 2.165-2.166-2.164z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 299.246l2.165 2.165-2.165-2.164z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 299.246l2.165 2.165-2.165-2.164z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 299.246l2.165 2.165-2.165-2.164z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 301.41l2.166 2.167-2.166-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 301.41l2.165 2.167-2.165-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 301.41l2.166 2.167-2.165-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 301.41l2.166 2.167-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 301.41l2.166 2.167-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 301.41l2.165 2.167-2.165-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 301.41l2.165 2.167-2.165-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 301.41l2.166 2.167-2.166-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 301.41l2.165 2.167-2.165-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 303.577l-2.165 6.496 2.165-6.496z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 303.577l2.166 2.165-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 303.577l2.165 2.165-2.165-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 303.577l2.166 2.165-2.165-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 303.577l2.166 2.165-2.166-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 303.577l2.165 2.165-2.165-2.165z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 303.577l2.166 2.165-2.166-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 303.577l2.165 2.165-2.165-2.165z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.138 305.027l.723 1.444-.722-1.443z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 305.742l2.166 2.166-2.167-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 305.742l2.164 2.166-2.165-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 305.742l2.166 2.166-2.166-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 305.742l2.165 2.166-2.165-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 305.742l2.166 2.166-2.165-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 305.742l2.166 2.166-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 305.742l2.166 2.166-2.166-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 305.742l2.165 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 305.742l2.165 2.166-2.166-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 305.742l2.165 2.166-2.165-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.88 306.457l1.443.722-1.442-.723z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 305.742l2.167 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 305.742l2.165 2.166-2.165-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 307.908l2.167 2.165-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 307.908l2.165 2.165-2.165-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 307.908l2.165 2.165-2.165-2.165z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 307.908l2.166 2.165-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 307.908l2.166 2.165-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 307.908l2.166 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 307.908l-2.166 4.33 2.166-4.33z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 307.908l2.165 2.165-2.165-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 307.908l2.166 2.165-2.166-2.165z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 307.908l2.165 2.165-2.165-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 310.073l2.167 2.166-2.166-2.167z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 310.073l4.33 4.33-4.33-4.33z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 310.073l2.166 2.166-2.166-2.167zm19.49 0l2.165 2.166-2.165-2.167z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 310.073l2.166 2.166-2.166-2.167z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 310.073l2.165 2.166-2.165-2.167z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 310.073l2.166 2.166-2.166-2.167z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 310.073l2.165 2.166-2.165-2.167z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 310.073l2.166 2.166-2.166-2.167z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 310.073l2.165 2.166-2.165-2.167z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 310.073l2.165 2.166-2.165-2.167z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 310.073l2.165 2.166-2.164-2.167z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 310.073l2.167 2.166-2.166-2.167z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 310.073l2.166 2.166-2.167-2.167z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 312.24l2.167 2.164-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 312.24l2.165 2.164-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 312.24l2.166 2.164-2.165-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 312.24l2.165 2.164-2.165-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.91 312.953l1.44.722-1.44-.722z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 312.24l2.165 2.164-2.165-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 312.24l2.166 2.164-2.167-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 312.24l2.166 2.164-2.166-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 312.24l2.165 2.164-2.164-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 312.24l2.164 2.164-2.165-2.165z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 312.24l2.166 2.164-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.817 314.404l2.166 2.166-2.166-2.166z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 314.404l2.165 2.166-2.165-2.166z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 314.404l2.165 2.166-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 314.404l2.165 2.166-2.165-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 314.404l2.166 2.166-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 314.404l2.166 2.166-2.166-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 314.404l2.165 2.166-2.165-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 314.404l2.166 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 314.404l2.165 2.166-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 314.404l2.167 2.166-2.166-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 314.404l2.165 2.166-2.165-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 314.404l2.166 2.166-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.402 314.404l2.166 2.166-2.166-2.166z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 316.57l2.165 2.165-2.166-2.165z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 316.57l2.165 2.165-2.165-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 316.57l2.166 2.165-2.167-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 316.57l2.165 2.165-2.165-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 316.57l2.166 2.165-2.165-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 316.57l2.165 2.165-2.165-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 316.57l2.167 2.165-2.166-2.165m30.318 0l2.166 2.165-2.166-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 316.57l2.165 2.165-2.165-2.165z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 318.735l2.166 2.166-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 318.735l2.164 2.166-2.165-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 318.735l2.166 2.166-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 318.735l2.166 2.166-2.165-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 318.735l2.166 2.166-2.165-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 318.735l2.166 2.166-2.166-2.165z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 318.735l2.167 2.166-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 318.735l2.165 2.166-2.166-2.165z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.085 318.735l2.166 2.166-2.165-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 320.9l2.166 2.166-2.166-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 320.9l2.166 2.166-2.165-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 320.9l2.166 2.166-2.166-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 320.9l2.165 2.166-2.164-2.165m36.813 0l2.165 2.166-2.166-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 320.9l2.166 2.166-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 323.066l2.165 2.166-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 323.066l2.165 2.166-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 323.066l2.165 2.166-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 323.066l2.165 2.166-2.164-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 323.066l2.165 2.166-2.166-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 323.066l2.166 2.166-2.165-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 325.232l2.165 2.165-2.166-2.165z",
    fill: "#d3d079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 325.232l2.165 2.165-2.165-2.165zm25.986 0l2.165 2.165-2.166-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 325.232l2.165 2.165-2.164-2.165m36.813 0l2.165 2.165-2.166-2.165z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 325.232l2.166 2.165-2.166-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 325.232l2.165 2.165-2.164-2.165z",
    fill: "#f2f1d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.117 326.682l.723 1.444-.723-1.444z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.028 328.848l.723 1.443-.722-1.442z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 327.397l2.165 2.166-2.165-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 327.397l2.165 2.166-2.166-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 327.397l2.165 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 327.397l2.166 2.166-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.62 328.848l.723 1.443-.723-1.442z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 329.563l2.165 2.165-2.165-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 329.563l2.166 2.165-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 329.563l2.165 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 329.563l-2.165 4.33 2.165-4.33z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 329.563l2.165 2.165-2.164-2.165z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 329.563l2.165 2.165-2.165-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 329.563l2.166 2.165-2.166-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.402 329.563l2.166 2.165-2.166-2.165z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.697 333.18l.723 1.44-.723-1.44z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 331.728l2.166 2.166-2.167-2.166m6.497 0l2.165 2.166-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 331.728l2.166 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 331.728l2.166 2.166-2.166-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 331.728l2.166 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 331.728l2.167 2.166-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 331.728l2.165 2.166-2.165-2.166z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 331.728l4.33 4.33-4.33-4.33z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.62 333.18l.723 1.44-.723-1.44z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.117 333.18l.723 1.44-.723-1.44z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.518 335.344l.723 1.443-.722-1.443z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 333.894l2.166 2.165-2.165-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 333.894l2.166 2.165-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 333.894l2.166 2.165-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 333.894l2.165 2.165-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 333.894l2.165 2.165-2.165-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 333.894l2.167 2.165-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 333.894l2.166 2.165-2.166-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.983 336.06l2.165 2.165-2.165-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 336.06l2.165 2.165-2.166-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 336.06l2.166 2.165-2.165-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 336.06l2.165 2.165-2.166-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 336.06l2.165 2.165-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 336.06l2.166 2.165-2.166-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 336.06l2.165 2.165-2.166-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 336.06l2.165 2.165-2.166-2.166m10.827 0l2.165 2.165-2.165-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 336.06l2.165 2.165-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 336.06l2.165 2.165-2.164-2.166z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.983 338.225l2.165 2.165-2.165-2.165z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 338.225l2.165 2.165-2.166-2.165z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.518 339.675l.723 1.443-.722-1.443z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 338.225l2.166 2.165-2.165-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 338.225l2.166 2.165-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 338.225l2.165 2.165-2.164-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 338.225l2.165 2.165-2.165-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 338.225l2.166 2.165-2.166-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 338.225l2.165 2.165-2.166-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 338.225l2.165 2.165-2.166-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 338.225l2.165 2.165-2.165-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 338.225l2.166 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 338.225l2.165 2.165-2.166-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 338.225l2.165 2.165-2.164-2.165z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.983 340.39l2.165 2.166-2.165-2.166z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 340.39l2.165 2.166-2.166-2.166z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 340.39l2.166 2.166-2.165-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 340.39l2.165 2.166-2.164-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 340.39l2.166 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 340.39l2.165 2.166-2.165-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 340.39l2.166 2.166-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 340.39l2.165 2.166-2.166-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 340.39l2.165 2.166-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 340.39l2.166 2.166-2.166-2.166m17.324 0l2.166 2.166-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 340.39l2.165 2.166-2.165-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 340.39l2.166 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 340.39l2.165 2.166-2.165-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 340.39l2.166 2.166-2.166-2.166z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 340.39l2.165 2.166-2.166-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.237 340.39l2.165 2.166-2.165-2.166z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.983 342.556l2.165 2.165-2.165-2.164z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.863 344.006l.723 1.443-.723-1.444z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 342.556l2.165 2.165-2.166-2.164z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 342.556l2.166 2.165-2.167-2.164z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 342.556l2.166 2.165-2.166-2.164z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 342.556l2.167 2.165-2.166-2.164z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 342.556l2.165 2.165-2.165-2.164z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 342.556l2.166 2.165-2.166-2.164z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 342.556l2.165 2.165-2.165-2.164z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 342.556l2.165 2.165-2.165-2.164z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 342.556l2.166 2.165-2.166-2.164z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 342.556l2.166 2.165-2.166-2.164z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 342.556l2.165 2.165-2.166-2.164z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 342.556l2.165 2.165-2.166-2.164z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.237 342.556l2.165 2.165-2.165-2.164z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 344.72l2.165 2.167-2.166-2.166z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 344.72l2.166 2.167-2.167-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.962 344.72l2.165 2.167-2.165-2.166m19.49 0l2.165 2.167-2.166-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 344.72l2.165 2.167-2.165-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 344.72l2.166 2.167-2.165-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 344.72l2.166 2.167-2.165-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 344.72l2.166 2.167-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 344.72l2.165 2.167-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 344.72l2.165 2.167-2.165-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 344.72l2.166 2.167-2.166-2.166z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.237 344.72l2.165 2.167-2.165-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.148 346.887l2.166 2.165-2.166-2.165z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 346.887l2.165 2.165-2.166-2.165z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 346.887l2.166 2.165-2.166-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 346.887l2.165 2.165-2.165-2.165z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 346.887l2.167 2.165-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 346.887l2.166 2.165-2.167-2.165z",
    fill: "#fcb755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 346.887l2.164 2.165-2.165-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 346.887l2.166 2.165-2.166-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 346.887l2.165 2.165-2.165-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 346.887l2.165 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 346.887l2.165 2.165-2.166-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 346.887l2.166 2.165-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 346.887l2.166 2.165-2.166-2.165z",
    fill: "#e0dea1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.237 346.887l2.165 2.165-2.165-2.165z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.148 349.052l2.166 2.166-2.166-2.166z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 349.052l2.165 2.166-2.165-2.166z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 349.052l2.164 2.166-2.165-2.166z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 349.052l2.166 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 349.052l2.165 2.166-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 349.052l2.165 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 349.052l2.165 2.166-2.165-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 349.052l2.166 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 349.052l2.165 2.166-2.164-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 349.052l2.167 2.166-2.166-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 349.052l2.166 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 349.052l2.165 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 349.052l2.166 2.166-2.165-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 349.052l2.166 2.166-2.166-2.166z",
    fill: "#e1e18c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.786 350.503l.723 1.442-.724-1.442z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.237 349.052l2.165 2.166-2.165-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.148 351.218l2.166 2.165-2.166-2.165z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 351.218l2.165 2.165-2.165-2.165z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 351.218l2.164 2.165-2.165-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 351.218l2.166 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 351.218l2.165 2.165-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 351.218l2.166 2.165-2.166-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 351.218l2.166 2.165-2.165-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 351.218l2.166 2.165-2.166-2.165z",
    fill: "#d4d456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.148 353.383l2.166 2.166-2.166-2.167z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 353.383l2.165 2.166-2.165-2.167z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 353.383l2.164 2.166-2.165-2.167z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 353.383l2.166 2.166-2.166-2.167z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 353.383l2.166 2.166-2.166-2.167z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 353.383l2.166 2.166-2.166-2.167z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 353.383l2.166 2.166-2.165-2.167z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07 353.383l2.167 2.166-2.166-2.167z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.148 355.55l2.166 2.164-2.166-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 355.55l2.165 2.164-2.166-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 355.55l2.165 2.164-2.165-2.165z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 355.55l2.166 2.164-2.166-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 355.55l2.165 2.164-2.165-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.085 355.55l2.166 2.164-2.165-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 355.55l2.165 2.164-2.165-2.165z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07 355.55l2.167 2.164-2.166-2.165z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 357.714l2.165 2.166-2.166-2.166z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 357.714l2.165 2.166-2.165-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 357.714l2.165 2.166-2.165-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 357.714l2.166 2.166-2.165-2.166z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.39 358.43l1.444.722-1.443-.723z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 357.714l-2.164 4.33 2.165-4.33z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 357.714l2.165 2.166-2.165-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 357.714l-2.166 4.33 2.166-4.33z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 357.714l2.165 2.166-2.165-2.166z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07 357.714l2.167 2.166-2.166-2.166z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 359.88l2.165 2.165-2.166-2.165z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 359.88l2.166 2.165-2.166-2.165z",
    fill: "#f2f1d2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 359.88l2.166 2.165-2.165-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 359.88l2.165 2.165-2.165-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 359.88l2.166 2.165-2.165-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 359.88l2.166 2.165-2.165-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 359.88l2.166 2.165-2.166-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 359.88l2.167 2.165-2.166-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 359.88l2.165 2.165-2.165-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 359.88l2.165 2.165-2.165-2.165z",
    fill: "#d9d868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 359.88l2.165 2.165-2.164-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.07 359.88l2.167 2.165-2.166-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 362.045l2.165 2.166-2.166-2.165z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 362.045l2.166 2.166-2.166-2.165z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 362.045l4.332 4.33-4.33-4.33z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 362.045l2.166 2.166-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 362.045l2.166 2.166-2.165-2.165z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 362.045l2.166 2.166-2.166-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 362.045l2.165 2.166-2.164-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 362.045l2.164 2.166-2.165-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 362.045l2.166 2.166-2.166-2.165z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 362.045l2.165 2.166-2.166-2.165z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 362.045l2.165 2.166-2.164-2.165z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.314 364.21l2.165 2.166-2.166-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 364.21l2.165 2.166-2.166-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 364.21l2.166 2.166-2.166-2.165z",
    fill: "#d4d456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 364.21l2.166 2.166-2.165-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 364.21l2.165 2.166-2.165-2.165z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 364.21l2.166 2.166-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 364.21l2.166 2.166-2.167-2.165z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 364.21l2.165 2.166-2.166-2.165z",
    fill: "#eeedc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 364.21l2.165 2.166-2.164-2.165z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 366.376l2.165 2.166-2.166-2.166z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 366.376l2.165 2.166-2.164-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 366.376l2.166 2.166-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 366.376l2.166 2.166-2.166-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.324 367.827l.723 1.442-.723-1.443z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 366.376l2.165 2.166-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 366.376l2.165 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 366.376l2.166 2.166-2.166-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 366.376l2.165 2.166-2.165-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 366.376l2.165 2.166-2.166-2.166z",
    fill: "#d3d079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 366.376l2.166 2.166-2.166-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.906 366.376l2.165 2.166-2.164-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 368.542l2.165 2.165-2.166-2.165z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 368.542l2.165 2.165-2.164-2.165z",
    fill: "#e0dea1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 368.542l2.166 2.165-2.165-2.165z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 368.542l2.165 2.165-2.165-2.165z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 368.542l2.166 2.165-2.167-2.165z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 368.542l2.164 2.165-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 368.542l2.166 2.165-2.165-2.165z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 368.542l2.165 2.165-2.165-2.165z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 368.542l2.166 2.165-2.166-2.165z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.48 370.707l2.165 2.166-2.166-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 370.707l2.165 2.166-2.165-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 370.707l2.165 2.166-2.164-2.166z",
    fill: "#d4d456"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 370.707l2.166 2.166-2.165-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 370.707l2.166 2.166-2.165-2.166m10.828 0l2.166 2.166-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 370.707l2.165 2.166-2.166-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 370.707l2.165 2.166-2.166-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 370.707l2.167 2.166-2.166-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 370.707l2.165 2.166-2.165-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 370.707l2.166 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 370.707l2.166 2.166-2.166-2.166z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 370.707l2.165 2.166-2.165-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 370.707l2.166 2.166-2.166-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 370.707l2.165 2.166-2.165-2.166z",
    fill: "#fbc477"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 370.707l2.166 2.166-2.166-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 370.707l2.165 2.166-2.164-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 370.707l2.167 2.166-2.166-2.166z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 370.707l2.165 2.166-2.166-2.166z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 370.707l2.166 2.166-2.166-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 372.873l2.165 2.165-2.165-2.165z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 372.873l2.167 2.165-2.166-2.165z",
    fill: "#f2f1d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 372.873l2.165 2.165-2.165-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 372.873l2.166 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 372.873l2.165 2.165-2.165-2.165z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 372.873l2.166 2.165-2.166-2.165z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 372.873l2.166 2.165-2.166-2.165z",
    fill: "#fea522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 372.873l2.165 2.165-2.164-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 372.873l2.165 2.165-2.166-2.165z",
    fill: "#dddc7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 372.873l2.165 2.165-2.165-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.74 372.873l2.166 2.165-2.166-2.165z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.645 375.038l2.165 2.166-2.165-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.525 376.49l.723 1.44-.723-1.44z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 375.038l2.167 2.166-2.166-2.166z",
    fill: "#d3d079"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 375.038l2.166 2.166-2.165-2.166z",
    fill: "#f9d099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 375.038l2.166 2.166-2.165-2.166z",
    fill: "#fcb144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 375.038l2.166 2.166-2.166-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.962 375.038l2.165 2.166-2.165-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 375.038l2.166 2.166-2.166-2.166z",
    fill: "#fef8f1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 375.038l2.166 2.166-2.166-2.166z",
    fill: "#f8dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 375.038l2.166 2.166-2.166-2.166z",
    fill: "#fcf1e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 375.038l2.166 2.166-2.166-2.166z",
    fill: "#f6f6e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 375.038l2.165 2.166-2.165-2.166z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 377.204l2.165 2.165-2.165-2.166z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 377.204l2.166 2.165-2.166-2.166z",
    fill: "#fbbe66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 377.204l2.165 2.165-2.165-2.166z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 377.204l2.166 2.165-2.166-2.166z",
    fill: "#e1e18c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 377.204l2.165 2.165-2.165-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 379.37l2.166 2.165-2.166-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 379.37l2.165 2.165-2.165-2.166z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 379.37l2.166 2.165-2.166-2.166z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 379.37l2.165 2.165-2.166-2.166z",
    fill: "#fdab33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 379.37l2.165 2.165-2.165-2.166z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 379.37l2.165 2.165-2.166-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.575 379.37l2.165 2.165-2.165-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.81 381.535l2.166 2.165-2.166-2.165z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 381.535l2.165 2.165-2.164-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 381.535l2.165 2.165-2.165-2.165z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 381.535l2.165 2.165-2.165-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 381.535l2.165 2.165-2.166-2.165z",
    fill: "#fe9f11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 381.535l2.165 2.165-2.166-2.165z",
    fill: "#fbead6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 381.535l2.165 2.165-2.165-2.165z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 381.535l2.165 2.165-2.166-2.165z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.976 383.7l2.165 2.166-2.164-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 383.7l2.166 2.166-2.166-2.166z",
    fill: "#e5e3af"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.317 385.15l.723 1.443-.723-1.442z",
    fill: "#faca88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 383.7l2.165 2.166-2.166-2.166z",
    fill: "#fae3c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 383.7l2.166 2.166-2.166-2.166z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 383.7l2.165 2.166-2.166-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.41 383.7l2.165 2.166-2.166-2.166m-123.434 2.166l2.165 2.165-2.164-2.164z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.14 385.866l2.167 2.165-2.166-2.164z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 385.866l2.166 2.165-2.166-2.164z",
    fill: "#d0d045"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 385.866l2.165 2.165-2.165-2.164z",
    fill: "#fbfaf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 385.866l2.166 2.165-2.166-2.164z",
    fill: "#f9d6aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 385.866l2.166 2.165-2.166-2.164z",
    fill: "#e5e59d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 385.866l2.165 2.165-2.166-2.164M310.14 388.03l2.167 2.167-2.166-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 388.03l2.165 2.167-2.165-2.166z",
    fill: "#8cbf84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.57 388.03c7.52 15.83 34.12 53.17 54.44 52.443 19.734-.706 42.02-37.14 50.737-52.442H317.57z",
    fill: "#0cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 388.03l2.166 2.167-2.166-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.244 388.03l2.165 2.167-2.166-2.166m-119.103 2.167l2.167 2.165-2.166-2.165z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 390.197l2.165 2.165-2.165-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 390.197l2.165 2.165-2.165-2.165z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 390.197l2.166 2.165-2.167-2.165z",
    fill: "#1ac5b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 390.197l2.165 2.165-2.165-2.165z",
    fill: "#68b070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 390.197l2.166 2.165-2.166-2.165z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307 392.362l2.165 2.166-2.165-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 392.362l2.166 2.166-2.167-2.166z",
    fill: "#7fb15c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 392.362l2.166 2.166-2.166-2.166z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 392.362l-2.166 4.33 2.166-4.33z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.078 392.362l2.166 2.166-2.166-2.166m-114.77 2.166l2.164 2.165-2.165-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 394.528l4.33 4.33-4.33-4.33z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 394.528l2.164 2.165-2.165-2.165z",
    fill: "#34be9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 394.528l2.166 2.165-2.166-2.165z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.913 394.528l2.165 2.165-2.165-2.165z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.472 396.693l2.166 2.166-2.166-2.167z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 396.693l2.164 2.166-2.165-2.167z",
    fill: "#a2b23d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 396.693l2.166 2.166-2.166-2.167z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 396.693l2.166 2.166-2.165-2.167z",
    fill: "#5bb47c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 396.693l2.166 2.166-2.166-2.167z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 398.86l2.165 2.164-2.165-2.165z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 398.86l2.166 2.164-2.166-2.165z",
    fill: "#74b166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.085 398.86l2.166 2.164-2.165-2.165z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 398.86l-2.166 4.33 2.166-4.33z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.747 398.86l2.166 2.164-2.166-2.165z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.638 401.024l2.165 2.166-2.165-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 401.024l4.33 4.33-4.33-4.33z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 401.024l2.165 2.166-2.165-2.166z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 401.024l2.165 2.166-2.165-2.166z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.085 401.024l2.166 2.166-2.165-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.582 401.024l2.165 2.166-2.165-2.166z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.803 403.19l2.166 2.165-2.167-2.165z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 403.19l2.165 2.165-2.165-2.165z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 403.19l2.166 2.165-2.165-2.165z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 403.19l2.165 2.165-2.165-2.165z",
    fill: "#74b166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 403.19l2.166 2.165-2.166-2.165z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 405.355l2.164 2.166-2.165-2.165z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 405.355l2.166 2.166-2.165-2.165z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 405.355l2.166 2.166-2.165-2.165z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 405.355l2.166 2.166-2.166-2.165z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 405.355l-4.33 6.497 4.33-6.497z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.416 405.355l2.166 2.166-2.166-2.165z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.97 407.52l2.164 2.166-2.165-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 407.52l2.166 2.166-2.166-2.165z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 407.52l2.166 2.166-2.165-2.165z",
    fill: "#7fb15c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 407.52l2.164 2.166-2.165-2.165z",
    fill: "#34be9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.25 407.52l2.166 2.166-2.165-2.165z",
    fill: "#3a3a7c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.134 409.686l2.166 2.166-2.166-2.166z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 409.686l23.82 23.82-23.82-23.82z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 409.686l2.166 2.166-2.166-2.166z",
    fill: "#74b166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 409.686l2.166 2.166-2.167-2.166z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 409.686l2.164 2.166-2.165-2.166z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.085 409.686l2.166 2.166-2.165-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.3 411.852l2.165 2.165-2.165-2.165z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.962 411.852l2.165 2.165-2.165-2.165z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 411.852l-8.662 10.827 8.662-10.828z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 411.852l2.166 2.165-2.167-2.165z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 411.852l2.165 2.165-2.165-2.165z",
    fill: "#737370"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.465 414.017l2.166 2.166-2.165-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 414.017l2.166 2.166-2.166-2.166z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 414.017l2.165 2.166-2.165-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 414.017l-2.165 4.33 2.164-4.33z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.92 414.017l2.165 2.166-2.165-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.63 416.183l2.166 2.165-2.165-2.165z",
    fill: "#53527c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 416.183l2.165 2.165-2.165-2.165z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 416.183l2.166 2.165-2.166-2.165z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.754 416.183l2.166 2.165-2.166-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.796 418.348l2.166 2.166-2.166-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 418.348l2.166 2.166-2.166-2.166z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 418.348l2.165 2.166-2.165-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 418.348l-4.33 6.497 4.33-6.497z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.59 418.348l2.164 2.166-2.165-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.962 420.514l2.165 2.165-2.165-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 420.514l2.165 2.165-2.166-2.166z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 420.514l2.167 2.165-2.166-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.423 420.514l2.166 2.165-2.167-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.127 422.68l2.166 2.165-2.166-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 422.68l2.165 2.165-2.166-2.166z",
    fill: "#68b070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 422.68l2.166 2.165-2.166-2.166z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 422.68l2.165 2.165-2.164-2.166z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.258 422.68l2.165 2.165-2.165-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.293 424.845l2.165 2.165-2.165-2.165z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 424.845l2.165 2.165-2.165-2.165z",
    fill: "#74b166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 424.845l2.165 2.165-2.165-2.165z",
    fill: "#34be9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 424.845l2.166 2.165-2.166-2.165z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 424.845l-2.166 4.33 2.167-4.33z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.092 424.845l2.166 2.165-2.166-2.165z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.458 427.01l2.166 2.166-2.166-2.166z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 427.01l2.166 2.166-2.166-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 427.01l2.165 2.166-2.164-2.166z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 427.01l2.165 2.166-2.166-2.166z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.927 427.01l2.165 2.166-2.165-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.624 429.176l2.165 2.165-2.166-2.164z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 429.176l2.165 2.165-2.164-2.164z",
    fill: "#a2b23d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 429.176l2.167 2.165-2.166-2.164z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 429.176l2.165 2.165-2.166-2.164z",
    fill: "#74b166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 429.176l-6.496 8.662 6.496-8.662z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.596 429.176l2.165 2.165-2.164-2.164z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.76 429.176l2.167 2.165-2.166-2.164z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.79 431.34l2.165 2.167-2.166-2.166z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 431.34l2.167 2.167-2.166-2.166z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 431.34l2.165 2.167-2.165-2.166z",
    fill: "#42bb92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 431.34l2.165 2.167-2.165-2.166z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 431.34l2.166 2.167-2.166-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.43 431.34l2.166 2.167-2.166-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.955 433.507l2.165 2.165-2.165-2.165z",
    fill: "#1b1b74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 433.507l2.166 2.165-2.166-2.165z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 433.507l2.166 2.165-2.166-2.165z",
    fill: "#74b166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 433.507l2.165 2.165-2.165-2.165z",
    fill: "#0dc9c1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 433.507l2.166 2.165-2.166-2.165z",
    fill: "#34be9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 433.507l2.165 2.165-2.165-2.165z",
    fill: "#adb333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.265 433.507l2.165 2.165-2.165-2.165z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.12 435.672l2.166 2.166-2.166-2.166z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.286 435.672l2.165 2.166-2.164-2.166z",
    fill: "#6e6c70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 435.672l4.332 4.33-4.33-4.33z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 435.672l2.165 2.166-2.165-2.166z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 435.672l2.166 2.166-2.167-2.166z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 435.672l2.165 2.166-2.165-2.166z",
    fill: "#68b070"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.1 435.672l2.165 2.166-2.166-2.166z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.45 437.838l2.167 2.165-2.166-2.165z",
    fill: "#49497d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 437.838l2.164 2.165-2.165-2.165z",
    fill: "#5bb47c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 437.838l2.166 2.165-2.165-2.165z",
    fill: "#27c2aa"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 437.838l2.166 2.165-2.166-2.165z",
    fill: "#96b247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 437.838l-2.166 4.33 2.166-4.33z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.768 437.838l2.166 2.165-2.166-2.165z",
    fill: "#808067"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.934 437.838l2.165 2.165-2.166-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.617 440.003l2.165 2.166-2.165-2.167z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 440.003l2.166 2.166-2.166-2.167z",
    fill: "#8d8d5b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 440.003l2.166 2.166-2.166-2.167z",
    fill: "#8bb252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 440.003l2.165 2.166-2.165-2.167z",
    fill: "#1ac5b5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 440.003l2.166 2.166-2.165-2.167z",
    fill: "#5bb47c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.603 440.003l2.165 2.166-2.165-2.167z",
    fill: "#58587b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.782 442.17l2.166 2.164-2.166-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.948 442.17l2.165 2.164-2.165-2.165z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.113 442.17l2.166 2.164-2.167-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 442.17l2.165 2.164-2.165-2.165z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.437 442.17l2.166 2.164-2.166-2.165m-17.324 2.164l2.166 2.166-2.167-2.166z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.28 444.334l2.164 2.166-2.165-2.166z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 444.334l2.166 2.166-2.165-2.166z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.106 444.334l2.166 2.166-2.166-2.166z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.272 444.334l2.165 2.166-2.165-2.166M364.28 446.5l2.164 2.165-2.165-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.444 446.5l2.166 2.165-2.166-2.165z",
    fill: "#667"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 446.5l2.165 2.165-2.165-2.165z",
    fill: "#a4a43d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 446.5l2.166 2.165-2.165-2.165z",
    fill: "#99994e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 446.5l2.166 2.165-2.165-2.165z",
    fill: "#32327b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.61 448.665l2.165 2.166-2.165-2.165z",
    fill: "#262678"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.775 448.665l2.166 2.166-2.165-2.165z",
    fill: "#0e0e6e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.94 303.577c3.342 7.86 14.055 16.537 17 20.79-3.75 4.254-4.498 3.79-4.006 11.692 6.518-6.82 6.635-7.532 10.827-6.497 9.185 9.164 1.645 28.846-5.945 33.125-7.588 4.565-6.21-.158-17.584 5.563 5.215 4.46 11.257-.653 16.194.714 2.683 3.183-1.275 8.984.81 14.448 4.364-.42 3.84-9.23 4.855-12.423 3.187-11.704 22.352-19.866 23.326-30.6 4.04-1.897 8.08-.593 12.993 2.166-2.448-10.057-10.543-9.95-12.712-13.09-5.165-7.892-9.743-16.896-20.774-19.23-8.374-1.775-7.748.532-13.114-3.128-3.335-2.603-13.49-7.523-11.867-3.532z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.017 312.505a1.746 1.746 0 1 1-3.495-.001 1.746 1.746 0 0 1 3.497.001z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16 336.92c5.386-6.627 8.055-20.153 10.44-24.744 5.512 1.327 5.452 2.206 12.21-1.92-9.076-2.577-9.76-2.348-10.803-6.538 3.812-12.402 24.737-14.93 32.066-10.218 7.58 4.577 2.762 5.566 13.134 12.95 1.506-6.695-5.837-9.648-6.936-14.652 1.563-3.86 8.54-3.07 12.398-7.466-2.41-3.662-9.954.917-13.253 1.51-11.836 2.65-28.005-10.482-37.95-6.33-3.566-2.686-4.3-6.866-4.157-12.5-7.748 6.863-3.87 13.97-5.634 17.355-4.566 8.254-10.388 16.507-7.3 27.352 2.344 8.23 4.09 6.6 3.362 13.055-.744 4.164-.35 15.443 2.42 12.142z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.805 311.46a1.747 1.747 0 0 1 2.36.728 1.745 1.745 0 1 1-3.087 1.63 1.746 1.746 0 0 1 .727-2.358z",
    fillRule: "evenodd",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.94 341.57c-8.457-1.184-21.414 3.528-26.576 3.862-1.715-5.403-.932-5.807-7.958-9.455 2.488 9.1 3.037 9.566-.008 12.627-12.586 3.152-25.573-13.45-25.332-22.158-.005-8.856 3.334-5.243 4.288-17.938-6.508 2.173-5.237 9.985-8.95 13.514-4.112.66-7.046-5.72-12.803-6.748-1.886 3.957 5.935 8.045 8.15 10.56 8.39 8.76 5.514 29.39 14.213 35.755-.455 4.44-3.652 7.23-8.548 10.02 9.88 3.083 13.957-3.91 17.767-4.153 9.425-.363 19.5.35 27.184-7.902 5.833-6.265 3.533-6.916 9.435-9.63 3.95-1.518 13.398-7.69 9.14-8.353z",
    fill: "#f90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.887 357.608a1.746 1.746 0 1 1 1.8-2.995 1.746 1.746 0 0 1-1.8 2.996z",
    fillRule: "evenodd",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.5d494fc607400d8c11c3e23783b38355.svg";
export { ForwardRef as ReactComponent };